import { createI18n } from 'vue-i18n';
import ar from './ar.json';
import en from './en.json';

const savedLocale = localStorage.getItem('locale') as 'ar' | 'en' | null;
const defaultLocale = (import.meta.env.VITE_DEFAULT_LOCALE as 'ar' | 'en') || 'ar';

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale ?? defaultLocale,
  fallbackLocale: 'en',
  messages: { ar, en },
});

export function setLocale(locale: 'ar' | 'en') {
  i18n.global.locale.value = locale;
  localStorage.setItem('locale', locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
}

export default i18n;
